// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XabaG","left":"styles_left__cnP-0","desktopActions":"styles_desktopActions__3w4_G","title":"styles_title__2QRZ4"};